import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Benefits } from "./components/Benefits";
import { Process } from "./components/Process";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { SEO } from "./components/SEO";

export default function App() {
  return (
    <div className="min-h-screen bg-gray-950">
      <SEO />
      <Header />
      <Hero />
      <Services />
      <Benefits />
      <Process />
      <Contact />
      <Footer />
    </div>
  );
}
